// extracted by mini-css-extract-plugin
export default {"inactive":"MainMenu_inactive__-PBNS","active":"MainMenu_active__4+nY1"};